import { useNavigate } from '@tanstack/react-router'
import { SiteViewAssetVizWrapper } from 'features/siteView/components/assetVizPanel/SiteViewAssetVizWrapper'
import React, { FC, useState } from 'react'
import styled, { CSSProperties } from 'styled-components'
import { GeckoAssetModel, GeckoComponent, GeckoComponentDataFrame } from 'types'

const Panel = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  background-color: rgba(0, 0, 0, 0.3);

  transition:
    width 200ms,
    height 200ms;

  &:hover {
    width: 250px;
    height: 250px;
  }
`

const NavigateLink = styled.div`
  cursor: pointer;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 40px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  font-size: 20px;
  text-align: center;
  line-height: 40px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.6);
  }
`

export const SiteViewAssetVizPanel: FC<{
  selectedAssetModel: GeckoAssetModel
  selectedComponent: GeckoComponent
  selectedCDF: GeckoComponentDataFrame
  style?: CSSProperties
}> = ({ selectedAssetModel, selectedComponent, selectedCDF, style }) => {
  const navigate = useNavigate()
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Panel
      style={style}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <SiteViewAssetVizWrapper
        selectedAssetModel={selectedAssetModel}
        selectedComponent={selectedComponent}
        selectedCDF={selectedCDF}
      />
      {isHovered && (
        <NavigateLink
          onClick={() =>
            navigate({
              to: '/details/$entryID',
              from: '/overview/$siteID',
              params: { entryID: selectedComponent.id },
              search: { cdf: selectedCDF.id },
            })
          }>
          See full details -{'>'}
        </NavigateLink>
      )}
    </Panel>
  )
}
